// extracted by mini-css-extract-plugin
export default {"loadingBox":"Home_loadingBox__DtR5o","empty":"Home_empty__suB2V"};